import { SHAPE_STROKE_PROPS } from './stroke-props';

interface ArrowShapeProps {
  strokeDasharray: string | undefined;
}

export default function ArrowShape({ strokeDasharray }: ArrowShapeProps) {
  // Block-arrow profile pointing right.
  return (
    <path
      d="M 0 35 L 60 35 L 60 15 L 100 50 L 60 85 L 60 65 L 0 65 Z"
      strokeDasharray={strokeDasharray}
      {...SHAPE_STROKE_PROPS}
    />
  );
}
